import { Feature, StepType, Variable } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import { getInitialValues as getInitialAdaptiveCardValues } from './AdaptiveCard/AdaptiveCardOperation'
import { getInitialValues as getInitialAPIRequestValues } from './APIRequestOperation'
import { getInitialValues as getInitialBooleanValues } from './Boolean/BooleanOperation'
import { getInitialValues as getInitialCustomCodeValues } from './CustomCodeOperation'
import { getInitialValues as getInitialDataSourceValues } from './DataSourceOperation'
import { getInitialValues as getInitialDataStorageValues } from './DataStorageOperation'
import { getInitialValues as getInitialDataTransformValues } from './DataTransform/DataTransformOperation'
import { getInitialValues as getInitialDeployFeatureValues } from './DeployFeatureOperation'
import { getInitialValues as getInitialDocumentSearchStorageValues } from './DocumentSearchStorageOperation'
import { getInitialValues as getInitialDocumentTextSplitter } from './DocumentTextSplitterOperation'
import { getInitialValues as getInitialFileDownloadValues } from './FileDownloadOperation'
import { getInitialValues as getInitialFileUploadValues } from './FileUploadOperation'
import { getInitialValues as getInitialGenerateMicroappTokenValues } from './GenerateMicroappToken'
import { getInitialValues as getInitialInvokeLambdaValues } from './InvokeLambdaOperation'
import { getInitialValues as getInitialKnnSearchValues } from './KnnSearchOperation'
import { getInitialValues as getInitialLogValues } from './LogOperation'
import { getInitialValues as getInitialLoopValues } from './LoopOperation'
import { getInitialValues as getInitialNotificationDateFormatterValues } from './Notification/DateFormatterOperation'
import { getInitialValues as getInitialNotificationDeleteValues } from './Notification/DeleteOperation'
import { getInitialValues as getInitialNotificationValues } from './Notification/NotificationOperation'
import { getInitialValues as getInitialNotificationViewValues } from './NotificationView'
import { getInitialValues as getInitialRagPromptValues } from './RagPromptOperation'
import { getInitialValues as getInitialResponseValues } from './ResponseOperation'
import { getInitialValues as getInitialRunFeatureValues } from './RunFeatureOperation'
import { getInitialValues as getInitialSetConfigVariableValues } from './SetConfigVariableOperation'
import { getInitialValues as getInitialTextToEmbeddingsValues } from './TextToEmbeddingsOperation'
import { getInitialValues as getInitialUserLookupValues } from './UserLookupOperation'
import { getInitialValues as getInitialWorkgridDataSourceValues } from './WorkgridDataSourceOperation'

const getInitialStepValuesPerOperation = () =>
  new Map<
    StepType,
    (T: { data?: any; feature?: any; variables?: Variable[][]; app?: any; agentsFlagOn?: boolean }) => any
    // @ts-expect-error
  >([
    [StepType.Log, getInitialLogValues],
    [StepType.Boolean, getInitialBooleanValues],
    [StepType.Loop, getInitialLoopValues],
    [StepType.CustomCode, getInitialCustomCodeValues],
    [StepType.Notification, getInitialNotificationValues],
    [StepType.NotificationView, getInitialNotificationViewValues],
    [StepType.NotificationDateFormatter, getInitialNotificationDateFormatterValues],
    [StepType.NotificationDelete, getInitialNotificationDeleteValues],
    [StepType.DataSource, getInitialDataSourceValues],
    [StepType.APIRequest, getInitialAPIRequestValues],
    [StepType.DataStorage, getInitialDataStorageValues],
    [StepType.DataTransform, getInitialDataTransformValues],
    [StepType.Response, getInitialResponseValues],
    [StepType.RunFeature, getInitialRunFeatureValues],
    [StepType.DeployFeature, getInitialDeployFeatureValues],
    [StepType.UserLookup, getInitialUserLookupValues],
    [StepType.FileUpload, getInitialFileUploadValues],
    [StepType.FileDownload, getInitialFileDownloadValues],
    [StepType.DocumentTextSplitter, getInitialDocumentTextSplitter],
    [StepType.TextToEmbeddings, getInitialTextToEmbeddingsValues],
    [StepType.KnnSearch, getInitialKnnSearchValues],
    [StepType.RagPrompt, getInitialRagPromptValues],
    [StepType.AdaptiveCard, getInitialAdaptiveCardValues],
    [StepType.SetConfigVariable, getInitialSetConfigVariableValues],
    [StepType.DocumentSearchStorage, getInitialDocumentSearchStorageValues],
    [StepType.WorkgridDataSource, getInitialWorkgridDataSourceValues],
    [StepType.InvokeLambda, getInitialInvokeLambdaValues],
    [StepType.GenerateMicroappToken, getInitialGenerateMicroappTokenValues]
  ])

/**
 * Returns a validation schema based on StepType or TriggerType
 * @param {object} args
 * @param {string} args.type - The string from StepType enum
 * @param {object} args.data - The step data to avoid resetting data in the form
 */
const getInitialValuesByType = ({
  type,
  app,
  data = {},
  feature,
  variables,
  agentsFlagOn = false
}: {
  type: StepType
  app?: any
  data?: any
  feature?: Feature
  variables?: Variable[][]
  agentsFlagOn?: boolean
}) => {
  if (getInitialStepValuesPerOperation().get(type)) {
    // @ts-expect-error figure it out TS
    return getInitialStepValuesPerOperation().get(type)(data, feature, variables, app, agentsFlagOn)
  }

  return {}
}

export default getInitialValuesByType
